/* eslint-disable no-shadow */
import { useEffect, useRef, useState } from 'react';

export default ({ startDate, endDate }) => {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [status, setStatus] = useState('');
  const timer = useRef(null);
  const countDownDate = new Date(startDate).getTime();

  const getCountdownValues = () => {
    const now = new Date().getTime();
    const timeleft = countDownDate - now;

    const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

    return {
      days, hours, minutes, seconds, timeleft,
    };
  };

  const startTimerTick = () => {
    if (!countDownDate) return;

    const currentTime = new Date().getTime();
    const endTime = new Date(endDate).getTime();

    const {
      days, hours, minutes, seconds, timeleft,
    } = getCountdownValues();

    if (currentTime > endTime) {
      setStatus('ended');
      return clearInterval(timer.current);
    }

    if (timeleft < 0) {
      return setStatus('live');
    } 
    
    setStatus('upcoming');
    setDays(days);
    setHours(hours);
    setMinutes(minutes);
    setSeconds(seconds);
  };

  useEffect(() => {
    if (countDownDate) {
      const currentTime = new Date().getTime();
      const endTime = new Date(endDate).getTime();
      const startTime = countDownDate;

      if (currentTime > endTime) return setStatus('ended');
      if (startTime <= currentTime) setStatus('live');
      if (startTime > currentTime) setStatus('upcoming');

      // Set initial values
      const {
        days, hours, minutes, seconds,
      } = getCountdownValues();

      setDays(days);
      setHours(hours);
      setMinutes(minutes);
      setSeconds(seconds);

      timer.current = setInterval(startTimerTick, 1000);

      return () => clearInterval(timer.current);
    }
  }, [countDownDate]);

  return {
    days,
    hours,
    minutes,
    seconds,
    status,
  };
};
